/**
 * クラス名：装置設定の取付き時間（サイズ判断）画面
 * 作成者：チュー
 * 作成日：2023/06/01
 * バージョン：1.0
 */

import React, { useState, useEffect, forwardRef, useRef } from 'react';
import { Row, Col, Input, Button, Space, Popover } from 'antd';
import { PlusCircleFilled, CloseCircleFilled, CaretUpOutlined, CaretDownOutlined } from '@ant-design/icons';
import { Table } from 'react-bootstrap';
import { isEmpty } from '@rc-component/mini-decimal/es/numberUtil';
import { commonModal } from '../../../common/CommonModal';
import {
  souchiHandleIncreaseTime,
  souchiHandleDecreaseTime,
  secondsToHms,
  setTimetoSec,
  updateList,
  sortListByMasterData,
  getInputBorderStyle,
  handleKeyPress,
  regexExp,
  toHalfWidth,
  isDigitZenkaku,
  TimeInputParameterScreen,
} from '../../../common/Common';
const ToritsukiJikan_Size = forwardRef((props, ref) => {
  const [editMode, setEditMode] = useState(false);
  const [isSize, setIsSize] = useState(false);

  const [detailsSize, setDetailsSize] = useState([]);
  const [detailsSizeTemp, setDetailsSizeTemp] = useState([]);
  const [sizesList, setSizesList] = useState([]);
  const [kouteiTypeList, setKouteiTypeList] = useState([]);

  const [filterKeys, setFilterKeys] = useState([]);

  const [errIndexVal, setErrIndexVal] = useState([]);
  const [errorMessage, setErrorMessage] = useState('');
  const inputRef = useRef([]);
  useEffect(() => {
    setErrIndexVal([]);
    setErrorMessage('');
    setEditMode(props.editMode);

    setDetailsSize(props.detailsData?.instSizeThMaster);
    setDetailsSizeTemp(props.detailsData?.instSizeThMaster);
    setSizesList(props.detailsData?.instSizeThItems);

    setKouteiTypeList(props.processTypes);

    const usedIds = props?.processMstRecord?.details?.processDetailTypes
      ?.filter((item) => item.isUsed)
      ?.map((item) => item.id);
    setFilterKeys(usedIds);
  }, [props.editMode, props.detailsData, props.processTypes, props.processMstRecord]);

  const sizeModal = () => {
    setIsSize(true);
  };

  const addSizeModalTitle = (
    <div
      style={{
        width: 400,
        backgroundColor: '#005fab',
        marginLeft: -24,
        height: 36,
        marginTop: -20,
        borderTopLeftRadius: 7,
        borderTopRightRadius: 7,
        fontSize: 14,
      }}
    >
      <p style={{ paddingTop: 8, paddingLeft: 18, color: 'white' }}>サイズ</p>
    </div>
  );
  const addData = () => {
    setIsUpdateData(true);
  };

  const addSize = (id, index) => {
    inputRef.current[index].focus();
    const copyData = detailsSizeTemp.slice(); // Create a copy of the original array

    const insertIndex = detailsSizeTemp?.findIndex((item) => item.no === id); // Find the index of the item with id 2

    if (insertIndex !== -1) {
      const data = {
        no: detailsSizeTemp?.length + 1,
        value: 0,
        isOutOfRange: false,
      };
      copyData.splice(insertIndex + 1, 0, data); // Insert the new object after the found index
      setDetailsSizeTemp(copyData);
    }
  };

  const deleteSize = (id, e, index) => {
    // 更新するエラーインデックスを得る
    const updatedErrorIndexes = errIndexVal?.filter((item) => item !== index);

    const finalErrorIndexes = updatedErrorIndexes?.map((item) => (item > index ? item - 1 : item));
    setErrIndexVal(finalErrorIndexes);
    if (detailsSizeTemp?.filter((item) => item.isOutOfRange === false)?.length > 2) {
      const updatedData = detailsSizeTemp?.map((row) => {
        if (row.no === id) {
          return { ...row, isOutOfRange: true };
        }
        return row;
      });
      setDetailsSizeTemp(updatedData);
      const filterData = updatedData?.filter((i) => !i.isOutOfRange);
      if (index + 1 !== filterData?.length) {
        inputRef.current[index].focus();
      }
    }
  };
  const closeAddModal = () => {
    if (isSize === true) {
      setIsSize(false);
      setDetailsSizeTemp(detailsSize);
    }
  };
  const cancelAddModal = () => {
    if (isSize === true) {
      setErrIndexVal([]);
      setErrorMessage('');
      setIsSize(false);
      setDetailsSizeTemp(detailsSize);
    }
  };

  const handleSizeChange = (event, id, field) => {
    if (regexExp.test(event.target.value) && !isDigitZenkaku(event.target.value)) return;
    const updatedData = detailsSizeTemp?.map((row) => {
      if (row.no === id) {
        return { ...row, [field]: event.target.value };
      }
      return row;
    });
    setDetailsSizeTemp(updatedData);
  };

  const addSizeMaster = () => {
    const deletedId = [];

    detailsSize?.forEach((item1, index) => {
      const found = detailsSizeTemp?.find((item2) => item2.no === item1.no && item2.isOutOfRange === true);
      if (found) {
        deletedId.push(item1.no);
      }
    });

    const newId = detailsSizeTemp
      ?.filter((item) => !item.isOutOfRange && !detailsSize.some((data2Item) => data2Item.no === item.no))
      ?.map((item) => item.no);

    const updatedData = updateList(sizesList, deletedId, newId);
    const sortedList = sortListByMasterData(updatedData, detailsSizeTemp);

    setIsSize(false);
    setDetailsSize(detailsSizeTemp);

    setSizesList(sortedList);
    // IQX_WEBEST-271 サブ溶接にも溶接仕上を出来るようにしてほしい
    if (props?.isYosetsuFinish) {
      props.updatedSize(detailsSizeTemp, props.detailsData?.kouteiTypeId);
      props.updatedSizeList(sortedList, props.detailsData?.kouteiTypeId);
    } else {
      props.updatedSize(detailsSizeTemp);
      props.updatedSizeList(sortedList);
    }
  };
  const isValueOrderCorrect = (e, no, field) => {
    const temp = detailsSizeTemp?.filter((i) => i.isOutOfRange === false);

    const insertIndex = temp?.findIndex((item) => item.no === no);
    if (regexExp.test(temp[insertIndex].value) && !isDigitZenkaku(temp[insertIndex].value)) return;
    // IQX_WEBEST-220の対応-START
    if (regexExp.test(temp[insertIndex].value)) {
      // 全角の場合、
      temp[insertIndex].value = toHalfWidth(temp[insertIndex].value); // 半角へ変換
      e.target.value = temp[insertIndex].value;
      handleSizeChange(e, no, field);
    }
    if (isNaN(parseFloat(temp[insertIndex].value))) {
      setErrIndexVal([...errIndexVal, insertIndex]);
      setErrorMessage('数字値を入力してください！');
      return;
    }
    // IQX_WEBEST-220の対応-END

    if (insertIndex > 0) {
      const prevValue = parseFloat(temp[insertIndex - 1].value);
      const currentValue = parseFloat(temp[insertIndex].value);
      const nextValue = parseFloat(temp[insertIndex + 1].value);
      if (currentValue > prevValue && currentValue < nextValue) {
        let temp = [insertIndex - 1, insertIndex, insertIndex + 1];

        setErrIndexVal(errIndexVal?.filter((item) => item !== insertIndex && item != insertIndex - 1));

        setErrorMessage('前のしきい値より大きい値を入力してください！');
      } else {
        setErrIndexVal([...errIndexVal, insertIndex]);

        if (currentValue <= prevValue) {
          setErrorMessage('前のしきい値より大きい値を入力してください！');
        } else if (currentValue >= nextValue) {
          setErrorMessage('次のしきい値より小さい値を入力してください！');
        }
      }
    } else {
      const currentValue = parseFloat(temp[insertIndex].value);
      const nextValue = parseFloat(temp[insertIndex + 1].value);

      if (currentValue < nextValue) {
        setErrIndexVal(errIndexVal?.filter((item) => item !== insertIndex));
      } else {
        setErrIndexVal([...errIndexVal, insertIndex]);
        setErrorMessage('次のしきい値より小さい値を入力してください！');
      }
    }
  };
  const addSizeContent = (
    <>
      <div style={{ height: 400, overflow: 'auto' }}>
        <Row className="chargeAmount registerModal">
          <Col style={{ width: '100%' }}>
            <Table className="master-table">
              <thead>
                <tr style={{ textAlign: 'center' }}>
                  <th style={{ width: '20%' }} className="param-tbl-header">
                    No
                  </th>

                  <th style={{ width: '60%' }} className="param-tbl-header">
                    <Space>
                      <label>しきい値</label>（≦）
                    </Space>
                  </th>
                </tr>
              </thead>
              <tbody>
                {detailsSizeTemp
                  ?.filter((i) => i.isOutOfRange === false)
                  ?.map((item, index) => (
                    <tr key={index} style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                      <td>{index + 1}</td>

                      <td>
                        {errIndexVal?.includes(index) ? (
                          <Popover
                            content={<div style={{ padding: 7 }}>{errorMessage}</div>}
                            placement="left"
                            visible={true}
                          ></Popover>
                        ) : (
                          ''
                        )}
                        <Input
                          value={item.value}
                          onChange={(e) => handleSizeChange(e, item.no, 'value')}
                          onBlur={(e) => isValueOrderCorrect(e, item.no, 'value')}
                          onPressEnter={(e) => isValueOrderCorrect(e, item.no, 'value')}
                          className={errIndexVal?.includes(index) ? 'red-border' : ''}
                          style={{
                            ...getInputBorderStyle(index, detailsSizeTemp),
                            pointerEvents: editMode ? 'auto' : 'none',
                          }}
                          onKeyPress={(e) => {
                            handleKeyPress(e, false);
                          }}
                          ref={(ref) => (inputRef.current[index] = ref)}
                        ></Input>
                      </td>
                      <td
                        style={{ border: 'none', backgroundColor: 'white', verticalAlign: 'middle', width: '20%' }}
                        className="min"
                      >
                        <Row justify="center">
                          <PlusCircleFilled
                            onClick={() => addSize(item.no, index + 1)}
                            className="add-remove-icon"
                            style={{ marginLeft: 5, marginRight: 5, pointerEvents: editMode ? 'auto' : 'none' }}
                          />
                          <CloseCircleFilled
                            className="add-remove-icon"
                            onClick={(e) => deleteSize(item.no, e, index)}
                            style={{ pointerEvents: editMode ? 'auto' : 'none' }}
                          />
                        </Row>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          </Col>
        </Row>
      </div>
      <Row justify="center" className="mt-2">
        <Button className={isEmpty(errIndexVal) ? 'mainButton' : 'disabledButton'} id="update" onClick={addSizeMaster}>
          OK
        </Button>
        <Button className="cancelButton" style={{ marginLeft: 10 }} id="discard" onClick={cancelAddModal}>
          キャンセル
        </Button>
      </Row>
    </>
  );

  const sizeListDataChange = (event, key, no) => {
    const newList = { ...sizesList };
    const itemIndex = newList[key]?.findIndex((item) => item.no === no);

    if (itemIndex !== -1) {
      newList[key][itemIndex].value = event;
      setSizesList(newList);
      // IQX_WEBEST-271 サブ溶接にも溶接仕上を出来るようにしてほしい
      if (props?.isYosetsuFinish) {
        props.updatedSizeList(newList, props.detailsData?.kouteiTypeId);
      } else {
        props.updatedSizeList(newList);
      }
    }
  };
  return (
    <>
      <Table
        style={{
          width:
            detailsSize?.filter((i) => i.isOutOfRange === false)?.length > 4
              ? '100%'
              : detailsSize?.filter((i) => i.isOutOfRange === false)?.length * 210 + 196 + 'px',
          marginBottom: props?.isYosetsuFinish ? '0rem' : '1rem',
        }}
      >
        <tr style={{ textAlign: 'center', width: '100%' }}>
          <td style={{ width: '196px' }} className="param-tbl-header fixedCol">
            <Row justify="center" className="ant-row-no-bg-color">
              <Space>
                {props?.isYosetsuFinish ? '加工種類 /' : '取付種類 /'}
                {editMode ? (
                  <>
                    <Button className="cancleButton" onClick={sizeModal} style={{ pointerEvents: 'auto' }}>
                      サイズ
                    </Button>
                  </>
                ) : (
                  <>
                    <label>サイズ</label>
                  </>
                )}
              </Space>
            </Row>
          </td>

          {detailsSize
            ?.filter((i) => i.isOutOfRange === false)
            ?.map((item, index) => (
              <td key={index} style={{ width: '210px' }} className="param-tbl-header">
                ～M{item.value}
              </td>
            ))}
        </tr>
        {Object.keys(sizesList)
          ?.filter((listkey) => filterKeys?.includes(parseInt(listkey)))
          ?.map((key) => (
            <tr key={key} style={{ textAlign: 'center', width: '100%' }}>
              <td style={{ color: 'white', width: '196px' }} className="param-tbl-header fixedCol">
                {kouteiTypeList?.find((item) => item.id.toString() === key)?.name}
              </td>
              {sizesList[key]?.map((item, index) => (
                <td key={index} style={{ verticalAlign: 'middle', textAlign: 'center', width: 210 }}>
                  <Row align="middle">
                    {!editMode ? (
                      <>
                        <Col span={24}>
                          <label>{secondsToHms(item.value)}</label>
                        </Col>
                      </>
                    ) : (
                      <>
                        <Col span={10}>
                          {/* <Input
                            value={secondsToHms(item.value)}
                            onChange={(e) => sizeListDataChange(setTimetoSec(e.target.value), key, item.no)}
                          ></Input> */}
                          <TimeInputParameterScreen
                            value={secondsToHms(item.value)}
                            onBlur={(e) => sizeListDataChange(setTimetoSec(e.target.value), key, item.no)}
                          />
                        </Col>
                        <Col span={14}>
                          <CaretUpOutlined
                            style={{
                              fontSize: 16 + 'px',
                              marginLeft: 3,
                              pointerEvents: 'auto',
                            }}
                            onClick={() => {
                              let editedTime = souchiHandleIncreaseTime(secondsToHms(item.value), '10min');

                              sizeListDataChange(setTimetoSec(editedTime), key, item.no);
                            }}
                          />
                          <CaretDownOutlined
                            style={{
                              fontSize: 17 + 'px',
                              color: '#000',
                              pointerEvents: 'auto',
                            }}
                            onClick={() => {
                              let editedTime = souchiHandleDecreaseTime(secondsToHms(item.value), '10min');
                              sizeListDataChange(setTimetoSec(editedTime), key, item.no);
                            }}
                          />
                          <CaretUpOutlined
                            style={{
                              fontSize: 17 + 'px',
                              color: '#000',
                              pointerEvents: 'auto',
                            }}
                            onClick={() => {
                              let editedTime = souchiHandleIncreaseTime(secondsToHms(item.value), 'min');
                              sizeListDataChange(setTimetoSec(editedTime), key, item.no);
                            }}
                          />
                          <CaretDownOutlined
                            style={{
                              fontSize: 17 + 'px',
                              color: '#000',
                              pointerEvents: 'auto',
                            }}
                            onClick={() => {
                              let editedTime = souchiHandleDecreaseTime(secondsToHms(item.value), 'min');
                              sizeListDataChange(setTimetoSec(editedTime), key, item.no);
                            }}
                          />
                          <CaretUpOutlined
                            style={{
                              fontSize: 17 + 'px',
                              color: '#000',
                              pointerEvents: 'auto',
                            }}
                            onClick={() => {
                              let editedTime = souchiHandleIncreaseTime(secondsToHms(item.value), 'sec');
                              sizeListDataChange(setTimetoSec(editedTime), key, item.no);
                            }}
                          />
                          <CaretDownOutlined
                            style={{
                              fontSize: 17 + 'px',
                              color: '#000',
                              pointerEvents: 'auto',
                            }}
                            onClick={() => {
                              let editedTime = souchiHandleDecreaseTime(secondsToHms(item.value), 'sec');
                              sizeListDataChange(setTimetoSec(editedTime), key, item.no);
                            }}
                          />
                        </Col>
                      </>
                    )}
                  </Row>
                </td>
              ))}
            </tr>
          ))}
      </Table>
      {/* サイズ */}
      {isSize
        ? commonModal(
            isSize,
            addSizeModalTitle,
            null,
            null,
            400,
            addData,
            closeAddModal,
            addSizeContent,
            null,
            null,
            true
          )
        : ''}
    </>
  );
});

export default ToritsukiJikan_Size;
